import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import rootReducer from './reducers';

const composeEnhancers =
	(process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
	compose;

export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk /*, logger */)));
